import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
export function About() {
  const {
    t
  } = useLanguage();
  const stats = [{
    value: '+20',
    label: t('años recibiendo huéspedes', 'years hosting guests')
  }, {
    value: '+6',
    label: t('cabañas equipadas', 'fully equipped cabins')
  }, {
    value: '2',
    label: t('habitaciones con baño privado', 'rooms with private bathroom')
  }];
  return <section id="nosotros" className="py-24 bg-background" data-id="element-2" data-mp="33pf9dz1hvrmy">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3" data-mp="38p1mm8hbp7vr">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-4" data-mp="3dhb5j4k0t7oj">
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.5,
          ease: [0.23, 1, 0.32, 1]
        }} data-id="element-5" data-mp="3djfdbxl1iqu3">
            <span className="text-accent font-medium tracking-wider uppercase text-sm mb-3 block" data-id="element-6" data-mp="3rhm0ojsd58fi">
              {t('Acerca de nosotros', 'About us')}
            </span>
            <h2 className="text-3xl md:text-4xl font-serif text-primary mb-6" data-id="element-7" data-mp="2grmidsr7tron">
              {t('Más de 20 años recibiendo huéspedes en Dina Huapi', 'Over 20 years hosting guests in Dina Huapi')}
            </h2>

            <div className="space-y-4 text-gray-600 text-lg font-light leading-relaxed" data-id="element-8" data-mp="27tiy0zryv0yf">
              <p data-id="element-9" data-mp="34gx88f7121o0">
                {t('Cabañas Clarita hace más de 20 años en Dina Huapi, Argentina, ofreciendo una estadía tranquila en la hermosa Patagonia.', 'Cabañas Clarita has been in Dina Huapi, Argentina for over 20 years, offering a peaceful stay in beautiful Patagonia.')}
              </p>
              <p data-id="element-10" data-mp="3o5xxk4htgdfw">
                {t('Nuestras instalaciones cuentan con todo lo necesario para que te sientas como en casa.', 'Our facilities have everything you need to feel right at home.')}
              </p>
              <p data-id="element-11" data-mp="b4x6icubn4tp">
                {t('Disfruta de la tranquilidad de la naturaleza y practica pesca en uno de los mejores parajes de la provincia. Nuestro amable personal garantiza una experiencia inolvidable.', 'Enjoy the tranquility of nature and fish in one of the best spots in the province. Our friendly staff guarantees an unforgettable experience.')}
              </p>
            </div>

            <dl className="mt-10 grid grid-cols-3 gap-6 pt-8 border-t border-surface" data-id="element-12" data-mp="3okmfpurwglb0">
              {stats.map(stat => <div key={stat.label} data-id="element-13" data-mp="3alv7uq3mrvvb">
                  <dt className="sr-only" data-id="element-14" data-mp="3eldsrlvgc6y5">{stat.label}</dt>
                  <dd data-id="element-15" data-mp="3elx5mo68w55b">
                    <span className="block font-serif text-3xl text-primary" data-id="element-16" data-mp="18sp3p6tdq61a">
                      {stat.value}
                    </span>
                    <span className="block text-xs text-gray-500 mt-1 leading-snug" data-id="element-17" data-mp="1ct92sfxijjq2">
                      {stat.label}
                    </span>
                  </dd>
                </div>)}
            </dl>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.5,
          delay: 0.1,
          ease: [0.23, 1, 0.32, 1]
        }} className="relative" data-id="element-18" data-mp="2t8wn3nnx6ol2">
            <div className="aspect-[4/5] rounded-2xl overflow-hidden shadow-xl" data-id="element-19" data-mp="3h2er4xq7ongv">
              <img src="https://cdn.magicpatterns.com/uploads/bAoMsRb72fobdhzP5xe5h6/WhatsApp_Image_2026-09-02_at_4.01.07_PM_(2).jpg" alt={t('Cabañas Clarita cubiertas de nieve en invierno', 'Cabañas Clarita covered in snow in winter')} className="w-full h-full object-cover" data-id="element-20" data-mp="3c0xu5daull5k" />
            </div>
            <div className="absolute -bottom-6 -left-6 max-w-xs bg-white p-6 rounded-2xl shadow-lg border border-surface/60" data-id="element-21" data-mp="1qpz6c1ixmksk">
              <p className="font-serif text-lg text-primary leading-snug" data-id="element-22" data-mp="1x3uwdpfmwmps">
                {t('Cumplí tu sueño de conocer Bariloche con nosotros', 'Fulfill your dream of visiting Bariloche with us')}
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}